import { ImportSetAdminTranslation } from 'app/area/import-sets-administration/constants';
import { ImportSetFormIds } from 'app/area/import-sets-administration/form/constants';
import { ImportSetActionType } from 'app/area/import-sets-administration/form/types';
import * as React from 'react';
import { Numberbox } from 'ui';
import { InputControlContext } from 'ui/common/input-control-context';
import { ValidationProps } from 'ui/common/validation';
import styles from './import-database-id.scss';

interface ImportDatabaseIdProps {
  actionType: ImportSetActionType;
  value: number;
  required: boolean;
  readOnly: boolean;
  validation: ValidationProps;
  locale: string;
  translation: ImportSetAdminTranslation;
  onChange: (importDatabaseId: number) => void;
}

export const ImportDatabaseId = ({
  actionType, value, required, readOnly, validation, locale, translation, onChange
}: ImportDatabaseIdProps) =>
  actionType !== ImportSetActionType.edit
    ? <InputControlContext
      componentId={ImportSetFormIds.importDatabaseId}
      className={styles.importDatabaseId}
      label={{ text: translation.import_database_id }}
      validation={validation}>
      <div className="input-wrapper">
        <div className="input-group">
          <div className={`form-control ${styles.wrapper}`}>
            <textarea
              className={styles.textarea}
              disabled={true}
              value={translation.auto_info} />
          </div>
        </div>
      </div>
    </InputControlContext>
    : <Numberbox
      componentId={ImportSetFormIds.importDatabaseId}
      value={value}
      label={{ text: translation.import_database_id, required }}
      onChange={onChange}
      useThousand=" "
      readOnly={readOnly || actionType !== ImportSetActionType.edit}
      maxValue={999999999}
      validation={validation}
      locale={locale} />;
